import StoryTab from "./_storyTab.es6";
import TitleGlitch from "./_titleGlitch.es6";
import Music from "./_music.es6";
import Goods from "./_goods.es6";
import Fanclub from "./_fanclub.es6";
import Share from "./_share.es6";
import Anchor from "./_anchor.es6";
import FvGlitch from "./_fvGlitch.es6";
import NewteamMovie from "./_newteamMovie.es6";

const $howto4th = document.querySelector(".js-howto4th");
const $fv = document.querySelector(".howto4th-fv");
const $side = document.querySelector(".howto4th-side");
const storyTab = new StoryTab();
const titleGlitch = new TitleGlitch();
const music = new Music();
const goods = new Goods();
const fanclub = new Fanclub();
const share = new Share();
const anchor = new Anchor();
const fvGlitch = new FvGlitch();
const newteamMovie = new NewteamMovie();

if ($howto4th) {
    const updateSideVisibility = () => {
        if (!$fv || !$side) {
            return;
        }

        const isNarrow = window.matchMedia("(max-width: 768px)").matches;
        const isAfterFv = $fv.getBoundingClientRect().bottom <= 0;

        $side.classList.toggle("-hidden", isNarrow && isAfterFv);
    };

    // ページ全体のloadを待つと下部の画像まで待たされるため、FVの画像だけを待つ
    const $background = new Image();
    $background.src = window.getComputedStyle($fv.querySelector(".howto4th-fv__background")).backgroundImage.slice(5, -2);

    Promise.all([$background, ...$fv.querySelectorAll("img")].map(($image) => $image.decode().catch(() => {}))).then(() => {
        $howto4th.classList.add("-load");
        fvGlitch.start();
    });

    updateSideVisibility();
    window.addEventListener("resize", updateSideVisibility);
    window.addEventListener("scroll", updateSideVisibility, { passive: true });
}
